module.exports = __webpack_public_path__ + "1f6e74bd6cba2bd94e2df6ed0724c652.pdf";